import {HistoryStepForCallbacks} from "./historyStepForCallbacks";
import {HistoryController} from "./historyController";

export class HistoryStepFactory {
    private static historyController: HistoryController = null;

    public static setHistoryController(historyController: HistoryController) {
        HistoryStepFactory.historyController = historyController;
    }

    public static addHistoryStep(stepType, undo: () => void, redo: () => void) {
        if (HistoryStepFactory.historyController !== null) {
            HistoryStepFactory.historyController.addHistoryStep(
                new HistoryStepForCallbacks(HistoryStepFactory.historyController, stepType, undo, redo)
            );
        }
    }
}